import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import FontAwesome from 'react-fontawesome'
import { getPointData, removeSnowflakeData } from '../../services/applicationState'
import Snow from "../../components/Snow"
import './styles.css'

export default class ViewPage extends Component {
    static contextTypes = {
        host: PropTypes.string
    };

    state = {
        background: '#0053FF',
        imageUrl: null,
        status: 0,
        width: window.innerWidth
    }

    componentDidMount() {
        this.load()
        window.addEventListener('resize', this.setSize.bind(this))
    }
    componentWillUnmount() {
        window.removeEventListener('resize', this.setSize.bind(this))
    }

    setSize() {
        this.setState({ width: window.innerWidth})
    }

    load() {
        fetch(this.context.host + '/api/snowflakes/' + this.props.match.params.id)
            .then((result) => {
                //console.log(result)
                this.setState({ status: result.status })
                if (result.ok) {
                    return result.json();
                }
            }).then(data => {
                if (data) {
                    //console.log(data)
                    this.setState(data)
                }
            })
            .catch(err => {
                console.log("error")
                this.setState({ status: 404 })
            })
    }

    clear() {
        if (getPointData()) {
            removeSnowflakeData()
        }

        window.location.replace(process.env.PUBLIC_URL + '/create' || '/create');
    }

    render(props) {
        var color = {
            background: this.state.color,
        }

        var view = null;

        switch (this.state.status) {
            case 0:
                view = <div className='snow-spinner'></div>
                break;

            case 200:
                view =
                    (
                        <div className="view-page">
                            <div className='snowflake-container'>
                                <div className='snow-header'>
                                <button onClick={this.clear.bind(this)}><FontAwesome name='plus' />Create New</button>
                                    <Link to='/gallery' className='create-new'>
                                        <FontAwesome name='snowflake-o' />
                                        View Gallery
                                    </Link>
                                </div>
                                {!this.state.approved && <p className='pending'>Pending Approval</p>}
                                <Snow width={this.state.width} height={400 + 44} pointData={this.state.data}  />
                                <div className="flake">
                                    <img src={this.state.imageUrl} style={{width:'400px', height:'400px'}} alt='snowflake'/>
                                </div>
                                <div className="message" style={color}>
                                <p>{this.state.message}</p>
                                </div>
                            </div>
                        </div>
                    )
                break;

            default:
                view = <div className='retry'>Sorry, we cannot find the snowflake. </div>
                break;
        }
        return view

    }
}



// WEBPACK FOOTER //
// ./src/pages/ViewPage/index.js